import React from "react";
import PropTypes from "prop-types";
import "./EmptyState.css";

const DefaultIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 9.5 12 4l8 5.5V19a1.5 1.5 0 0 1-1.5 1.5H5.5A1.5 1.5 0 0 1 4 19V9.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 20.5v-6h6v6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default function EmptyState({
  title,
  description,
  icon,
  action,
  className = "",
  variant = "default",
}) {
  return (
    <div
      className={`empty-state empty-state--${variant}${className ? ` ${className}` : ""}`}
    >
      <div className="empty-state-icon" aria-hidden="true">
        {icon ?? <DefaultIcon />}
      </div>
      <h3 className="empty-state-title">{title}</h3>
      {description && <p className="empty-state-description">{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["default", "bordered"]),
};
